import { render, staticRenderFns } from "./PushArticle.vue?vue&type=template&id=0170c030&scoped=true"
import script from "./PushArticle.vue?vue&type=script&lang=js"
export * from "./PushArticle.vue?vue&type=script&lang=js"
import style0 from "./PushArticle.vue?vue&type=style&index=0&id=0170c030&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0170c030",
  null
  
)

export default component.exports